<template lang="html">
  <div class="ficha-receta wrapper">
    <section class="intro-receta row-center" v-if="!!data">
      <span
        class="background"
        :style="`background:url(${data.header_img.url}) center/cover no-repeat`"
      ></span>
    </section>

    <section class="fake-receta" v-if="!!!data">
      <section class="intro-receta row-center">
        <span class="background"></span>
      </section>
    </section>

    <section class="cuerpo-receta container row-start">
      <a href="javascript:history.go(-1)" class="volver row-start"
        >Volver a recetas</a
      >

      <aside class="ingredientes">
        <template v-if="!!data">
          <h2 class="hand-title">Ingredientes</h2>

          <img
            src="/static/img/decorado-simple.svg"
            alt="decorado"
            class="decorado"
            width="200"
          />

          <p v-for="(ingrediente, key) in data.ingredients" :key="key">
            {{ ingrediente | trim }}
          </p>
        </template>
      </aside>

      <main class="info-receta">
        <template v-if="!!data">
          <h1 class="hand-title" v-html="data.name"></h1>

          <img
            src="/static/img/decorado-simple.svg"
            alt="decorado"
            width="200"
            class="decorado"
          />

          <div class="stats row-center">
            <h3 class="tiempo row-center">
              <img src="/static/img/icon-tiempo.svg" alt="Duracion" />
              {{ data.tiempo }} minutos
            </h3>
            <h3 class="dificultad row-center">
              <img src="/static/img/icon-dificultad.svg" alt="Dificultad" />
              Dificultad
              <template v-if="data.dificulty == 0">
                Fácil
              </template>
              <template v-if="data.dificulty == 1">
                Normal
              </template>
              <template v-if="data.dificulty == 2">
                Difícil
              </template>
            </h3>
            <h3 class="raciones row-center">
              <img src="/static/img/icon-comensales.svg" alt="Raciones" />
              {{ data.portions }} Raciones
            </h3>
          </div>

          <p v-html="data.intro" v-if="!!data.intro"></p>
          <editorjs :object="data.object"></editorjs>

          <!-- <template v-for="(paso, key) in data.pasos">
            <h4 :key="key">Paso {{ Number(key) + 1 }}</h4>

            <div class="paso" v-html="paso"></div>
          </template> -->

          <div class="contenedor-categorias row-start">
            <!-- <router-link to="/">test</router-link> -->
            <router-link
              :to="$t('enlaces.recetas') + '?' + categoria.slug"
              v-for="(categoria, key) in data.category"
              :key="key"
              >{{ categoria.name }}</router-link
            >
          </div>

          <div class="rrss-share">
            <h3>Compartir en</h3>

            <img
              src="/static/img/decorado-simple.svg"
              alt="decorado"
              width="200"
            />

            <nav class="row-center">
              <a
                :href="
                  'http://www.facebook.com/sharer.php?u=' +
                    url +
                    '&t=' +
                    data.name
                "
                target="_blank"
                ><i class="fa fa-facebook"></i
              ></a>
              <a
                :href="
                  'http://twitter.com/intent/tweet?text=' +
                    data.name +
                    '&url=' +
                    url
                "
                target="_blank"
                ><i class="fa-brands fa-x-twitter"></i>
              </a>
              <a :href="'whatsapp://send?text=' + url"
                ><i class="fa fa-whatsapp"></i
              ></a>
            </nav>
          </div>
        </template>
      </main>
    </section>

    <template>
      <section class="ultimas-recetas">
        <div class="container">
          <h2 class="hand-title main-title">También te gustarán</h2>
        </div>
        <!-- v-if="data.category[0].name == receta.category[0].name" -->
        <div class="container row-start recetas-list" v-if="!!recipes">
          <receta-el
            :data="receta"
            :key="key"
            v-for="(receta, key) in recipes"
          ></receta-el>
        </div>

        <div class="container">
          <router-link
            :to="$t('enlaces.recetas')"
            tooltip="Más Recetas"
            class="classic-btn"
            >Más Recetas</router-link
          >
        </div>
      </section>
    </template>
  </div>
</template>

<script lang="js">

import receta from '@/components/parts/receta-el'

import axios from 'axios';
import VueAxios from 'vue-axios';
import editorjs from "@/components/views/editorjs";
import { mapGetters, mapActions } from "vuex";

export default  {
  name: 'ficha-receta',
  props: [],
  mounted() {
    this.getData();
    this.setData();
  },
  data() {
    return {
      data : '',
      recipes:[],
      catRecipe:[]
    }
  },
  watch : {
   "$route.params.id"() {
      this.getData();
      this.setData();
    },
    'getLanguage' : function(){
      this.getData();
      this.setData();
    },
    'catRecipe'(){
      this.setData();
    }
  },
  methods: {

    ...mapActions(["requestRecetaSlug", "requestReceta"]),
    getData() {

      this.requestRecetaSlug(this.$route.params.id).then(r => {
        if (r) {
          this.data = r;
          this.catRecipe = this.data.category[0].slug;
          document.head.querySelector("[name=title]").content = this.data.name;
          document.head.querySelector("[property='og:title']").content = this.data.name;
           document.head.querySelector("[name='twitter:title']").content = this.data.name;
           document.head.querySelector("[property='og:url']").content =
            location.href;
          document.title = this.data.name;
           if (this.data.header_img.url) {
              document.head.querySelector("[property='og:image']").content = this.data.header_img.url;
              document.head.querySelector("[name='twitter:image']").content = this.data.header_img.url;
          }

         
        }
      });
    },
    setData() {
        let data = {
          length: 3,
          order: [
            {
              name: "updated_at",
              direction: "desc",
            },
          ],
            filters: [
           {
            name: "category.slug",
            // search: this.catRecipe,
            search: this.catRecipe,
            textFilter: 1,
          },

          ],
          columns:[
            {
              name: "category",
              onlyLoad: true
            }
          ]


        };

        this.loading = true;

        this.requestReceta(data).then((r) => {
          this.recipes = r.data;

          // this.loading = false;
          // this.total = r.recordsFiltered;
        });

      }

  },
  computed : {
    ...mapGetters(['getServer', 'getLanguage']),
    url : function(){
      return location.href;
    }

  },
  components : {
    'editorjs': editorjs,
    'receta-el' : receta
  },
  filters : {
    trim : function(value){
      return value.trim();
    }
  }
}
</script>

<style scoped lang="scss">
.intro-receta {
  background: rgba(0, 0, 0, 0.19);
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0.19) 0%,
    rgba(246, 246, 246, 0.05) 74%,
    rgba(237, 237, 237, 0) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(0, 0, 0, 0.19)),
    color-stop(74%, rgba(246, 246, 246, 0.05)),
    color-stop(100%, rgba(237, 237, 237, 0))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0.19) 0%,
    rgba(246, 246, 246, 0.05) 74%,
    rgba(237, 237, 237, 0) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(0, 0, 0, 0.19) 0%,
    rgba(246, 246, 246, 0.05) 74%,
    rgba(237, 237, 237, 0) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(0, 0, 0, 0.19) 0%,
    rgba(246, 246, 246, 0.05) 74%,
    rgba(237, 237, 237, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.19) 0%,
    rgba(246, 246, 246, 0.05) 74%,
    rgba(237, 237, 237, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ededed', GradientType=0 );
}

.intro-receta .background {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: inline-block;
  background-position: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
}

.volver {
  position: absolute;
  left: 20px;
  top: -40px;
  text-transform: uppercase;
  color: #fff;
  font-family: "Raleway";
  background: #202c54;
  height: 25px;
  padding: 0 10px;
  font-size: 12px;
}

.volver::before {
  content: "";
  border: 6px solid transparent;
  border-right-color: white;
  display: inline-block;
  margin-right: 10px;
}

.cuerpo-receta {
  margin-top: -20vh;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-align-items: flex-start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  position: relative;
  z-index: 7;
  padding-bottom: 50px;
}

.ingredientes {
  width: 33.333333%;
  background: #202c54;
  color: white;
  padding: 110px 50px 50px 50px;
  text-align: center;
  min-height: 400px;
}

.ingredientes .hand-title {
  color: #fff;
  font-size: 26px;
}

.ingredientes .decorado {
  margin-top: 10px;
  margin-bottom: 20px;
}

.ingredientes p {
  color: #fff;
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 15px;
}

.info-receta {
  width: 66.6666666%;
  background: white;
  display: inline-block;
  padding: 100px 50px 50px 50px;
  min-height: 600px;
}

.info-receta .hand-title {
  font-family: "Raleway";
}

.info-receta .decorado {
  margin-top: 10px;
  margin-bottom: 20px;
}

.stats {
  margin-bottom: 40px;
}

.stats h3 {
  width: 33.333333333%;
  color: #b69645;
  text-transform: uppercase;
  font-size: 16px;
  font-family: "Raleway";
}

.stats h3 img {
  margin-right: 5px;
  width: 100%;
  max-width: 30px;
}

.paso {
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
  display: inline-block;
}

.info-receta p {
  text-align: left;
  margin-bottom: 40px;
  width: 100%;
  color: #202c54;
  font-size: 16px;
  line-height: 20px;
}

.paso p {
  font-size: 16px;
  line-height: 20px;
}

.info-receta h4 {
  text-transform: uppercase;
  font-weight: 800;
  color: #b69645;
  display: inline-block;
  text-align: left;
  margin-bottom: 5px;
  width: 100%;
  font-size: 22px;
  font-family: "Raleway";
}

.contenedor-categorias {
  margin-bottom: 40px;
  margin-top: 20px;
}

.contenedor-categorias a {
  padding: 5px;
  text-transform: uppercase;
  color: #fff;
  background: #967842;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-family: "philosopherregular";
}

.contenedor-categorias a:last-of-type {
  margin-right: 0;
}

.rrss-share a {
  padding: 10px;
  font-size: 24px;
  color: #202c54;
}

.rrss-share h3 {
  color: #212c55;
  font-size: 18px;
  font-family: "Raleway";
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: 800;
}

.ultimas-recetas {
  margin-top: 0px;
  padding-bottom: 50px;
}

.recetas-list {
  margin-bottom: 20px;
}

.recetas-list .receta-el:nth-child(4) {
  display: none;
}

.contenedor-imagen-secundaria {
  width: 90%;
  position: relative;
  margin: 0 auto;
  margin-bottom: 30px;
}

.contenedor-imagen-secundaria::before {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0.5;
  content: "";
  border: 20px solid white;
  pointer-events: none;
}

.contenedor-imagen-secundaria img {
  width: 100%;
  display: block;
}

@media screen and (max-width: 900px) {
  .ingredientes {
    width: 100%;
  }

  .info-receta {
    max-width: 100%;
    width: 100%;
  }

  .ultimas-recetas .receta-el:nth-child(4) {
    display: inline-block;
  }

  .cuerpo-receta {
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 700px) {
  .ingredientes {
    padding: 40px 20px 20px 20px;
  }

  .ingredientes p {
    font-size: 16px;
    line-height: 20px;
  }

  .info-receta {
    padding: 40px 20px 20px 20px;
  }

  .info-receta .hand-title {
    font-size: 24px;
  }

  .stats {
    margin-bottom: 20px;
  }

  .stats h3 {
    width: 100%;
    margin-bottom: 20px;
    justify-content: flex-start;
  }

  .stats h3:last-of-type {
    margin-bottom: 0;
  }

  .info-receta h4 {
    font-size: 18px;
  }

  .cuerpo-receta {
    padding-bottom: 20px;
  }

  .ultimas-recetas .hand-title.main-title {
    padding: 20px 0;
  }

  .recetas-list .receta-el:nth-child(4) {
    display: inline-block;
  }
}
@media screen and (max-width: 600px) {
  .contenedor-categorias a {
    padding: 10px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-receta.vue